<template>
  <div class="statistics">
    <!-- 面包屑 -->
    <breadcrumb></breadcrumb>
    <div class="echars">
      <tpl-detail titName="数据统计">
        <template slot="titRight">
          <download-all-zip url="/topic/exportTopicInfo"></download-all-zip>
        </template>
        <template slot="body">
          <div class="body-box" v-loading="loading">
            <el-row align="middle" type="flex">
              <!-- <el-col :span="4">
								<div class="tu">
									<div style="width:100%;height:100%" class="chart-class" ref="chart"></div>
								</div>
							</el-col> -->
              <el-col :span="8">
                <h3>活动教师</h3>
                <h4>
                  {{
                    statisticsInfo && statisticsInfo.activeStatistics.userCount
                  }}人
                </h4>
              </el-col>
              <!-- <el-col :span="7">
								<h3>签到教师</h3>
								<h4>签到: {{statisticsInfo && statisticsInfo.activeStatistics.firstSignCount}}人/签退: {{statisticsInfo && statisticsInfo.activeStatistics.secondSignCount}}人</h4>
							</el-col> -->
              <el-col :span="8">
                <h3>活动环节</h3>
                <h4>
                  {{
                    statisticsInfo &&
                    statisticsInfo.activeStatistics.nodeTopicCount
                  }}个
                </h4>
              </el-col>
              <el-col :span="8">
                <h3>活动成果</h3>
                <h4>
                  {{
                    statisticsInfo &&
                    statisticsInfo.activeStatistics.activeResultCount
                  }}个
                </h4>
              </el-col>
              <!-- <el-col :span="3">
								<h3>发言/回复数</h3>
								<h4>{{statisticsInfo && statisticsInfo.activeStatistics.speakCount}}个</h4>
							</el-col> -->
            </el-row>
          </div>
        </template>
      </tpl-detail>
    </div>

    <div class="hj">
      <tpl-detail titName="活动环节">
        <template slot="body">
          <div v-for="gi in groupList" :key="gi.actCode">
            <h1 class="act-tit">{{ gi.actTitle }}</h1>
            <ul>
              <li
                class="clearfix"
                v-for="(i, index) in gi.nodeList"
                :key="i.nodeCode"
                @click="toPathLink(i)"
              >
                <span class="fl">{{ index + 1 }}</span>
                <div class="fl">
                  <h1>{{ i.topic }}</h1>
                  <h2>
                    <i :class="mapLinkIcon(i.nodeType)"></i>
                    {{ i.nodeTypeDesc }}
                    <!-- <span class="cyd">参与度：{{i.documentParticipation}}%</span> -->
                  </h2>
                </div>
                <div class="right-box fr">
                  <i class="el-icon-arrow-right fr"></i>
                  <div class="fr">
                    <h6>{{ statis1(i) }}</h6>
                    <!-- <h6>{{statis2(i)}}</h6> -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </tpl-detail>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import TplDetail from "@/templates/TplDetail.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapFileIcon, mapLinkIcon } from "@/utils/index.js";
import { mapState } from "vuex";
import downloadAllZip from "@/components/downloadAllZip.vue";
export default {
  components: {
    Breadcrumb,
    TplDetail,
    downloadAllZip,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      loading: true,
      statisticsInfo: "",
      groupList: [], //按照主题对环节分组
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    mapLinkIcon,
    async init() {
      this.loading = true;
      this.statisticsInfo = await getData("/topic/getActiveStatisticsInfo", {
        actCode: sessionStorage.getItem("actCode"),
        isSub: 1,
      });
      this.headleGroup();
      this.initCharts();
      this.loading = false;
    },
    //分组
    headleGroup() {
      let groupList = []; //{actCode:'',actTitle:'',nodeList:[]}
      this.statisticsInfo.nodeTopicStatistics.forEach((si) => {
        if (groupList.map((gi) => gi.actCode).includes(si.actCode)) {
          groupList.find((gni) => gni.actCode == si.actCode).nodeList.push(si);
        } else {
          groupList.push({
            actCode: si.actCode,
            actTitle: si.actTitle,
            nodeList: [si],
          });
        }
      });
      this.groupList = groupList;
    },
    toPathLink(node) {
      //项目课题研究 主题活动绑定对应的环节

      //moduleType: "" //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究
      this.$router.push({
        name: "topicResearchPartake",
        query: {
          nodeCode: node.nodeCode,
          moduleType: "topic",
          nodeType: node.nodeType,
          actCode: node.actCode,
        },
      });
    },
    initCharts() {
      let bgColor = "#fff";
      let title = "平均参与度";
      let bfh = "%";
      let color = ["#F0F2F5", "#1890FF"];
      let echartData = [
        {
          name: "A类",
          value: "60",
        },
        {
          name: "B类",
          value: "41",
        },
      ];
      let option = {
        backgroundColor: bgColor,
        color: color,
        title: [
          {
            text:
              "{name|" +
              title +
              "}\n{val|" +
              this.statisticsInfo.activeStatistics.participation +
              "}{c|" +
              bfh +
              "}",
            top: "center",
            left: "center",
            textStyle: {
              rich: {
                name: {
                  fontSize: 12,
                  fontWeight: "normal",
                  color: "#666666",
                  padding: [10, 0],
                },
                val: {
                  fontSize: 22,
                  fontWeight: "bold",
                  color: "#1890FF",
                },
                c: {
                  fontSize: 22,
                  fontWeight: "bold",
                  color: "#1890FF",
                },
              },
            },
          },
          {
            top: 20,
            left: 20,
            textStyle: {
              fontSize: 14,
              color: "#666666",
              fontWeight: 400,
            },
          },
        ],
        series: [
          {
            type: "pie",
            radius: ["45%", "60%"],
            center: ["50%", "50%"],
            data: echartData,
            hoverAnimation: false,
            label: {
              show: false,
              position: "center",
            },
          },
        ],
      };

      // this.$nextTick(() => {
      // 	let myChart = this.$echarts.init(this.$refs.chart);
      // 	myChart.setOption(option);
      // });
    },
    //查看下载量统计
    //speakCount 发言
    //replyCount 回复
    //browseCount 查看
    //downloadCount 下载
    statis1(i) {
      let nodeType = i.nodeType;
      switch (nodeType) {
        case "speak":
        case "note":
        case "experience":
        case "summary":
        case "harvest":
          return i.speakReplyCount + "人参与";
        case "survey":
          return i.surveyCount + "人参与";
        case "eval":
          return i.evalCount + "人参与";
        case "homework":
          return i.homeworkCount + "人参与";
        default:
          return i.documentCount + "人参与";
      }
    },
    statis2(i) {
      let nodeType = i.nodeType;
      if (["speak", "eval", "survey"].includes(nodeType)) {
        return i.browseCount + "人回复";
      } else {
        return i.downloadCount + "人下载";
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.statistics {
  // padding: 10px 20px;
  .echars {
    margin-top: 15px;
    .body-box {
      padding: 15px 10px;
      text-align: center;
      font-size: 18px;
      .tu {
        margin: 0 auto;
        width: 210px;
        height: 210px;
        transform: scale(1.2);
      }
      h3 {
        font-size: 19px;
      }
      h4 {
        margin-top: 15px;
        font-size: 25px;
        color: @color;
      }
    }
  }
  .hj {
    //环节
    .act-tit {
      // border: 1px solid #000;
      margin-top: 20px;
      padding-bottom: 5px;
      margin-left: 15;
      font-size: 16.5px;
    }
    ul {
      padding-left: 10px;
      li {
        padding: 8px;
        padding-left: 15px;
        background-color: #f1f1f1;
        border-radius: 5px;
        cursor: pointer;
        margin-bottom: 15px;
        span {
          margin-top: 8px;
          border: 2px solid @color;
          color: @color;
          height: 30px;
          width: 30px;
          font-size: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 25px;
        }
        h1 {
          font-size: 15px;
          padding-left: 15px;
        }
        h2 {
          margin-top: 2px;
          font-size: 12px;
          padding-left: 15px;
          color: @hui;
          i {
            color: @color;
            font-size: 13px;
          }
          .cyd {
            font-size: 13px;
            margin-left: 20px;
            color: @color;
            border: none;
          }
        }
        .right-box {
          width: 200px;
          h6:nth-of-type(1) {
            margin-top: 3px;
            font-size: 14px;
            color: #000;
            text-align: center;
            line-height: 40px;
          }
          h6:nth-of-type(2) {
            font-size: 12px;
            color: @hui;
            text-align: center;
            line-height: 20px;
          }
          i {
            // border: 1px solid #000;
            font-size: 30px;
            margin: 10px 20px 0px 20px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
